import React from 'react';
import Lightbox from "yet-another-react-lightbox";
import {Link} from 'react-router-dom';
import MetaTags from "../components/MetaTags";

const OpletenieBousin: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Raznoe/kP9220010.jpg"},
        {src: "/image/Raznoe/kP5140003.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Оплетение бусин бисером и стеклярусом",
        "Оплетение бусин бисером и стеклярусом. Бусины можно оплетать используя разные цепочки. Бусины обтянутые бисером смотрятся очень эффектно и красиво."
    )

    return <>
        <h2>Оплетение бусин бисером и стеклярусом</h2>
        <p>Бусины обтянутые бисером смотрятся очень эффектно и красиво, например, на брелках.</p>
        <p>Для начала возьмите крупную бусину&nbsp;— деревянную, пластиковую или любую другую. Особенно хорошо смотрятся
            прозрачные бусины&nbsp;— на них ярче виден цвет бисера.</p>

        <p>Используя разные цепочки можно оплетать бусины по-разному. Сейчас возьмем за основу крестик.</p>
        <p>Сплетем полоску крестиком (рис.А). Чтобы шириной она покрывала основную часть бусины. Закрепляем цепочку,
            плотно обтянув бусину, и выводим один конец лески на другую сторону (рис.Б).</p>
        <p>Пропустим леску через все крайние бисеринки и затянем кольцо (рис.В). То же самое сделаем и с другим концом
            лески. Далее набираем по одной бисеринке и пропускаем леску через одну из колечка (рис.Г). Набранные
            бисеринки также затягиваем в кольцо. Набираем следующий ряд бисеринок, пропуская леску так же через одну
            (рис.Д). Затягиваем последний ряд в колечко. Набираем еще одну бисеринку, продеваем леску через одну в
            последнем ряду, потом еще одну (рис. Е).</p>

        <p>Проделываем то же самое с другой стороной бусины (рисунки Г и Д). Затягиваем колечко, проводим леску через
            бусину, последнюю набранную бисеринку навстречу леске, на которую уже набрана эта бисеринка.</p>
        <p>Теперь оба конца лески выводим на другую сторону бусины и набираем на них бисеринки до нужной длины, чтобы
            прикрепить куда-нибудь или сделать петельку для брелка (рис. Ж).</p>

        <p>Теперь изделие готово.</p>
        <img src="/image/Schema/opletenie_bousin.jpg" className="schema col-centered img-responsive" width="550"
             height="629" alt="ОПЛЕТЕНИЕ БУСИН БИСЕРОМ И СТЕКЛЯРУСОМ"/>
        <p>Вот несколько примеров моих изделий с бусинами, оплетенными бисером.</p>


        <div className="row">
            <div className="col-md-12">
                <img src="/image/Raznoe/mP9220010.jpg"
                     className="picture1 pic-left img-rounded"
                     width="227" height="170" alt="Солнце"
                     id="image-0"
                     onClick={viewImage}
                />
                <p className="text">Брелок «Солнышко». Я оплела бисером 5 деревянных бусин и повесила их на кольцо из <Link
                    to="/shnur">шнура</Link>.</p>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <img src="/image/Raznoe/mP5140003.jpg"
                     className="picture1 pic-left img-rounded"
                     width="227" height="170" alt="Брелок"
                     id="image-1"
                     onClick={viewImage}
                />
                <p className="text">Еще один брелок составлен из куба, выполненного в технике <Link
                    to="kvadrat-stolbik">квадратный столбик</Link> и бусины, оплетенной бисером.</p>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <img src="/image/Schema/opletenie_seregki.jpg" className="picture1 pic-left img-rounded" width="227"
                     height="131" alt="Сережки"/>
                <p className="text">А вот серьги&nbsp;— две прозрачные пластиковые бусины, оплетенные бисером и
                    стеклярусом. Они смотрятся воздушными из-за прозрачности бусин и ажурной цепочки в крестик,
                    обтягивающей их.</p>
            </div>
        </div>

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default OpletenieBousin;

